import { operations } from '@luxuryescapes/contract-cart/server';

export enum CartType {
  PENDING = 'pending',
  COMPLETED = 'completed',
  PURCHASED = 'purchased',
  ABANDONED = 'abandoned',
}

export type CartRawItem = NonNullable<
  operations['getCartsByUser']['responses'][200]['content']['application/json']['result']
>[number]['rawItems'][number];

export interface Cart {
  transactionKey: string;
  createdAt: number | null;
  rawItems: Array<CartRawItem>;
  type: CartType | null; // This is the cart status
  // Other fields are present, treat them as unknown.
  [key: string]: unknown;
}

export interface GetUserCartsParams {
  brand: string;
  sortDir: 'ASC' | 'DESC';
  page: number;
  limit: number;
  cartId?: string;
  createdAtFrom?: string;
  createdAtTo?: string;
  statuses?: Array<CartType>;
}

export interface GetUserCartsResponse {
  status: number;
  total: number;
  count: number;
  result: Array<Cart>;
}

export interface GetQuotesParams {
  page?: number;
  limit?: number;
  brand?: string;
  /** Filter to quotes created by this agent. Employees are scoped to their own by the service. */
  agentId?: string;
  /** Inclusive lower bound on created_at (ISO datetime). */
  createdFrom?: string;
  /** Inclusive upper bound on created_at (ISO datetime). */
  createdTo?: string;
}

export interface QuoteCartItem {
  itemId: string;
  itemType: string;
  itemProductId?: string | null;
  name?: string | null;
  status: string;
  orderId?: string | null;
  packageId?: string | null;
  bookingId?: string | null;
  dateLabel?: string | null;
}

export interface QuoteListItem {
  cartId: string;
  id?: string | null;
  agentId?: string | null;
  customerId?: string | null;
  customerEmailDedupeKey?: string | null;
  callbackDate?: string | null;
  createdAt?: string | null;
  expiresAt?: string | null;
  brand: string;
  multipleCustomerEmailDedupeKey?: string | null;
  /** Sell price of the underlying cart. Nullish — legacy carts were persisted without a total. */
  cartTotal?: number | null;
  /** Currency of `cartTotal` (e.g. 'AUD'), so the amount is interpretable across regions. */
  currency?: string | null;
  items: Array<QuoteCartItem>;
}

export interface GetQuotesResponse {
  total: number;
  result: Array<QuoteListItem>;
}
